import React from 'react';
import { Box } from '@mui/material';

import { FONT } from '../constants';

const BADGE_TONES = {
  secondary: { bg: '#f1f2f4', color: '#0f172a', border: 'none' },
  outline: { bg: 'transparent', color: '#0f172a', border: '1px solid #ddd' },
  success: { bg: '#dcfce7', color: '#15803d', border: 'none' },
} as const;

export type BadgeVariant = keyof typeof BADGE_TONES;

const Badge: React.FC<{ children: React.ReactNode; variant?: BadgeVariant }> = ({
  children,
  variant = 'secondary',
}) => {
  const tone = BADGE_TONES[variant];
  return (
    <Box
      component="span"
      display="inline-flex"
      alignItems="center"
      gap="5px"
      fontSize={FONT.sm}
      fontWeight={500}
      lineHeight={1.3}
      padding="3px 9px"
      borderRadius="6px"
      color={tone.color}
      bgcolor={tone.bg}
      border={tone.border}
      sx={{ whiteSpace: 'nowrap' }}
    >
      {children}
    </Box>
  );
};

export default Badge;
